import React, { useRef, useState } from "react";
import axios from "axios";
import { Form, FormikProvider, useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { backendServerBaseURL } from "../../utils/backendServerBaseURL";
import { useEffect } from "react";
import "../../assets/public/css/auth.css";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import { GoogleLogin } from "react-google-login";
import { Helmet } from "react-helmet-async";
import { clientId, recaptchKey } from "../../utils/constants";
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [passwordHide, setpasswordHide] = useState(true);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  localStorage.setItem("theme", "light");

  const RegisterSchema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required").min(8, "Password must contain at least 8 letters"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: RegisterSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      setSubmitting(true);

      // if (sessionStorage.getItem("recaptchaToken", null)) {
      await axios
        .post(`${backendServerBaseURL}/auth/login`, {
          username: values["username"],
          password: values["password"],
          recaptchToken: sessionStorage.getItem("recaptchaToken", ""),
          type: "normal",
        })
        .then((response) => {
          localStorage.setItem("selectedMenu", "dashboard");

          if (response.status === 200 && response.data.message === "Logged in Successfully") {
            localStorage.setItem("accessToken", response.data.payload.accessToken);
            localStorage.setItem("user", JSON.stringify(response.data.payload.user));

            navigate("/dashboard");
          }

          if (response.status === 200 && response.data.message === "2FA is enabled") {
            navigate(`/2-step-verification/${response.data.payload.twoFactorToken}`);
          }
        })
        .catch((error) => {
          try {
            console.log(error);
            if (error.response.status === 400) {
              setErrors({ afterSubmit: error.response.data.message });
            }

            if (error.response.data.message === "User email is not verified") {
              navigate(`/verify-email`);
            }
          } catch (e) {
            console.log(e);
          }
        });
      // } else {
      //   alert("Please complete recaptcha");
      // }

      setSubmitting(false);
    },
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  useEffect(() => {
    if (localStorage.getItem("accessToken", null) !== null && localStorage.getItem("accessToken", null) !== undefined) {
      localStorage.setItem("selectedMenu", "dashboard");
      window.open("/dashboard", "_self");
    }
  }, []);
  const handlePasswordShow = () => {
    setpasswordHide(!passwordHide);
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse);
      let userInfo = await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
      });

      let userData = userInfo.data;
      console.log(userData);

      try {
        await axios
          .post(`${backendServerBaseURL}/auth/login`, {
            username: userData.email,
            password: userData.sub + "24" + userData.email,
            recaptchToken: sessionStorage.getItem("recaptchaToken", ""),
            type: "google",
          })
          .then((response) => {
            console.log(response.data.data);
            if (response.status === 200 && response.data.message === "Logged in Successfully") {
              localStorage.setItem("accessToken", response.data.payload.accessToken);
              localStorage.setItem("user", JSON.stringify(response.data.payload.user));

              navigate("/dashboard");
            }

            if (response.status === 200 && response.data.message === "2FA is enabled") {
              navigate(`/2-step-verification/${response.data.payload.twoFactorToken}`);
            }
          })
          .catch((error) => {
            try {
              console.log(error);
              if (error.response.status === 400) {
                formik.setErrors({ afterSubmit: error.response.data.message });
              }

              if (error.response.data.message === "User email is not verified") {
                navigate(`/verify-email/${error.response.data.payload.id}`);
              }
            } catch (e) {
              console.log(e);
            }
          });
      } catch (error) {
        formik.setErrors({ afterSubmit: error });
      }
    },
    onError: (errorResponse) => console.log(errorResponse),
    onNonOAuthError: (errorResponse) => console.log(errorResponse),
  });

  useEffect(() => {
    const discordCode = params.get("code");

    if (discordCode) {
      axios
        .post(`${backendServerBaseURL}/auth/login`, {
          discordCode: discordCode,
          type: "discord",
        })
        .then((response) => {
          console.log(response.data.data);
          if (response.status === 200 && response.data.message === "Logged in Successfully") {
            localStorage.setItem("accessToken", response.data.payload.accessToken);
            localStorage.setItem("user", JSON.stringify(response.data.payload.user));

            navigate("/dashboard");
          }

          if (response.status === 200 && response.data.message === "2FA is enabled") {
            navigate(`/2-step-verification/${response.data.payload.twoFactorToken}`);
          }
        })
        .catch((error) => {
          try {
            console.log(error);
            if (error.response.status === 400) {
              // setErrors({ afterSubmit: error.response.data.message });
            }

            if (error.response.data.message === "User email is not verified") {
              navigate(`/verify-email/${error.response.data.payload.id}`);
            }
          } catch (e) {
            console.log(e);
          }
        });
    }
  }, []);

  const onSuccess = (res) => {
    console.log("logged in ", res.profileObj);
  };
  const onFailure = (res) => {
    console.log("failed ", res);
  };

  return (
    <section class="auth-section">
      <Helmet>
        <title>Login - LightningProxies</title>

        <script src="https://www.google.com/recaptcha/api.js" defer async></script>
      </Helmet>
      <div class="container-fluid">
        <div class="row justify-content-between">
          <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-6 d-none d-lg-block">
            <div className="auth-div flex-fill">
              {/* <img src="/assets/images/auth/log-bg.svg" alt="" className="img-fluid" /> */}
              <div className="d-flex flex-column text-start">
                <h2>
                  Welcome back to the #1 Network of <br />
                  Lightning Fast Proxies
                </h2>
                <p>Ready to experience the speed of LightningProxies again? Login and get started!</p>
              </div>
              <div className="d-flex ">
                <img src="./assets/images/auth/register-img.svg" alt="Register" class="img-fluid" />
              </div>
              <div className="d-flex ">
                <img src="./assets/images/auth/social-banner.svg" alt="Register" class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 left-part-auth">
            <div class="auth-logo-wrap text-start  ">
              <a href="#">
                <img src="./assets/images/logo.svg" alt="Logo" class="img-fluid" />
              </a>
            </div>
            <div class="signup-form-wrap login-form-box text-start flex-fill ">
              <h1 style={{ marginLeft: "0px" }}>Log In</h1>
              <p>Welcome back we’re glad to see you</p>

              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div class="form-group">
                    <label for="">Username</label>
                    <input
                      type="text"
                      {...getFieldProps("username")}
                      placeholder="Email or username"
                      class="pchold form-control brdr-gren"
                    />
                    <span
                      className="invalid-feedback"
                      style={{
                        display: Boolean(touched.username && errors.username) ? "block" : "none",
                      }}
                    >
                      {errors.username}
                    </span>
                  </div>
                  <div class="form-group">
                    <div class="d-flex">
                      <label for="">Password</label>
                      <a href="/forgot-password">Forgot Password?</a>
                    </div>
                    <input
                      type={passwordHide ? "password" : "text"}
                      placeholder="Create password"
                      class="form-control pchold"
                      id="password-field"
                      {...getFieldProps("password")}
                      webkit
                    />
                    <i class={passwordHide ? "fa fa-eye" : "fa fa-eye-slash"} onClick={() => handlePasswordShow()} id="eye-click"></i>
                    <span
                      className="invalid-feedback"
                      style={{
                        display: Boolean(touched.password && errors.password) ? "block" : "none",
                      }}
                    >
                      {errors.password}
                    </span>
                  </div>
                  <div className="d-flex justify-content-center my-4">
                    <div class="g-recaptcha" data-sitekey={recaptchKey} data-callback="recaptcha_callback"></div>
                  </div>
                  <div class="submit-bttn mb-5">
                    <button type="submit" class="btn btn-submit ">
                      Log in
                    </button>
                  </div>
                  {/* Errors from server */}
                  {errors.afterSubmit && (
                    <div className="alert alert-danger mb-5" role="alert">
                      {errors.afterSubmit}
                    </div>
                  )}
                </Form>
              </FormikProvider>

              <div class="credential-ftr-txt top-100">
                <p>&copy; 2023 Lightning Proxies. All rights reserved</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
